module.exports = __webpack_public_path__ + "static/media/sandwich.08d676a4.svg";